module.exports = [{"Shaft Max Length":true},{"Ring Max Length":true},{"Disc Max Diam":true},{"Ring Max Diam":true},{"Max Length":true},{"Max Height":true},{"Max Weight":true},{"Max Tons":true},{"Max Diam":true},{"Max Lbs":true},{"Max Id":false},{"Max Od":true},{"Max":true}]


//////////////////
// WEBPACK FOOTER
// ./src/config/maxDim.json
// module id = 5703
// module chunks = 1